/**
 * Modal Remove token - based
 * @return Void
 */
$(function()
{
  "use strict";

  /**
   * Attach the Remove behaviour to the #remove modal
   */
  $('#remove').on('show.bs.modal', function (event){
    // Button that triggered the modal
    var button  = $(event.relatedTarget)
    // If necessary, we can initiate an AJAX request here (and then do the updating in a callback).
    // Update the modal's content.
    // We'll use jQuery here.
    var modal = $(this)

    // Extract info from data-* attributes
    var action       = button.data('action') || modal.find('form').attr('action');
    var message      = button.data('message') || 'this record';
    var return_url   = button.data('return-url') || '';

    // set the action on the form
    modal.find('form').attr('action', action)
    modal.find('input[name="return_url"]').val(return_url)
    modal.find('#message').text(message)
  });

});
